<template>
	<v-row class="d-flex mb-2">
		<v-col cols="2" class="text-right mt-2">
			{{this.prependLabel}}
		</v-col>
		<v-col cols="8" class="align-self-bottom">
			<v-slider
			v-model="internalValue"
			:max="10"
			step="1"
			ticks="always"
			tick-size="4"
			thumb-size="128"
			track-color="grey lighten-3"
			color="grey lighten-3"
			thumb-color="grey lighten-1"
			v-on:input="$emit('input', $event)"
			>
			</v-slider>
		</v-col>
		<v-col cols="2" class="text-left mt-2">
			{{this.appendLabel}}
		</v-col>
  </v-row>
</template>

<script>
// import Vuetify from 'vuetify/lib'

export default {
	props:{
		prependLabel: String,
		appendLabel: String,
		value: Number,
	},
	mounted () {
		this.internalValue = this.value;
  },
	data: () => ({
		internalValue: 0,
	}),
	methods: {
	}
}
</script>

<style>
.v-slider__track-background {
  border-radius: 0 12px 12px 0;
	/* margin:0px -16px 0 0; */
}
.v-slider__track-fill {
 border-radius:12px 0 0 12px;
 /* margin:0 0 0 -16px; */
}

.v-slider--horizontal .v-slider__track-container {
  height:24px;
}

.v-slider__thumb {
  height: 36px;
  width:36px;
	border:8px solid;
}
.v-slider__thumb.grey.lighten-1 {background-color:white !important;}
.v-slider__thumb::before {
  height:44px;
  width:44px;
}

.v-slider__tick, .v-slider__tick--filled  {
		background:rgba(0,0,0,.25);
    border-radius: 100%;
}
</style>